<div class="tds-container-fluid">
  <div class="tds-landing-page__bgimage">
    <h1 class="tds-headline-01" style="color: white;margin-left: 1%;">Bem Vindo ao RENA</h1>
  </div>
</div>